import { ReactNode } from 'react';

type ActiveLinkProps = {
  children: ReactNode;
  onTap: () => void;
  isActive?: boolean;
  className?: string;
};

export const ActiveLink = ({
  children,
  onTap,
  isActive = true,
  className = '',
}: ActiveLinkProps) => {
  return (
    <button
      onClick={onTap}
      className={`
        print:hidden
        inline-flex items-center gap-1
        text-md font-medium
        duration-200
        ${isActive ? 'text-ivarioBlue' : 'text-grey2'}
        hover:text-ivarioBlue-hover
        disabled:opacity-50 disabled:cursor-not-allowed
        ${className}
      `}
    >
      {children}
    </button>
  );
};
